module.exports = __webpack_public_path__ + "static/media/Thumbnail-shristi-ko-fool.e8cdb668.png";